import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { OptInNotificationComponent, OptInNotificationContainer } from './';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        DirectivesModule,
    ],
    exports: [
        OptInNotificationContainer,
    ],
    declarations: [
        OptInNotificationComponent,
        OptInNotificationContainer,
    ],
    providers: [],
})
export class OptInNotificationModule { }
